export function userAuthHeaders() {
  if (typeof window === "undefined") return {};
  const token =
    window.localStorage.getItem("token") ||
    window.sessionStorage.getItem("token") ||
    "";
  return token ? { Authorization: `Bearer ${token}` } : {};
}
